/* eslint-disable no-useless-catch */

/**
 * Content system service
 */

// Constants
import { CONTENT_TYPE, HTTP_METHOD } from 'utils/constants';

// Configs
import AdminService from 'configs/api/adminService';
import { constructEndpoint } from 'utils/helper/common';

const ENDPOINTS = {
  API_GET_SERVICE_BY_ID: ['/services/{0}', HTTP_METHOD.GET],
  API_UPDATE_SERVICE: ['/services/{0}', HTTP_METHOD.POST],
};

class ContentSystemService extends AdminService {
  constructor() {
    super();
  }

  async getService(id: string | number) {
    try {
      const results = await this.request(constructEndpoint(ENDPOINTS.API_GET_SERVICE_BY_ID, [id]));

      return results?.data?.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async updateService(id: string | number, data: any) {
    try {
      const formData = new FormData();
      for (const key in data) {
        if (data[key] !== null) formData.append(key, data[key]);
      }
      const results = await this.request(
        constructEndpoint(ENDPOINTS.API_UPDATE_SERVICE, [id]),
        [],
        formData,
        null,
        CONTENT_TYPE.FORM_DATA
      );

      return results.data;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
}

export default new ContentSystemService();
